/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.membership.offerings.create.lifecycle.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.membership',
  'acme.common.service.membership.offering',
  'acme.common.service.rulesEngine',
  'acme.common.directive.ruleBar',
  'acme.common.factory.notice',
  'acme.view.application.membership.offerings.create.lifecycle.modals.remove.controllers',
  'acme.view.application.membership.offerings.create.lifecycle.modals.details.controllers'
])

  .controller('MembershipOfferingsCreateLifecycleController', ['$scope', '$state', '$uibModal', '$timeout', '$q', 'ApiService', 'MembershipService', 'MembershipOfferingService', 'RulesEngineService', 'NoticeFactory', function($scope, $state, $uibModal, $timeout, $q, ApiService, MembershipService, MembershipOfferingService, RulesEngineService, NoticeFactory) {

    $scope.membershipOfferingsCreateLifecycle = {

      model: [],
      offering: {},

      blocks: [],
      deletedRules: [],
      templateBlocks: [],
      afterTermMaxEndRange: 0,
      checkRangeTimer: false,
      ruleStartExpirationBasedOptions: RulesEngineService.getRuleStartExpirationBasedOptions(),

      notice: new NoticeFactory(),

      init: function() {

        $scope.$on('MembershipOfferingsCreateController::Save', this.onMembershipOfferingsCreateControllerSave);
        $scope.$on('MembershipOfferingsCreateController::Update', this.onMembershipOfferingsCreateControllerUpdate);
        $scope.$on('MembershipOfferingsCreateController::FocusTab', this.onMembershipOfferingsCreateControllerFocusTab);
        $scope.$on('RuleBar::DragUpdate', this.onRuleBarDragUpdate);

      },

      getBlockLabel: function(block) {

        var r = block.name;

        if (block.label === 'NEW_MEMBERSHIPS') {
          r = 'New Membership';
        }else if (block.label === 'CANCELLATION') {
          r = 'Cancel';
        }

        return r;

      },

      getBlockRestrictValues: function(block, selection) {
        var i, ii,
            r = [];

        for (i=0,ii=block.rules.length;i<ii;i++) {
          if (block.rules[i].selected &&
              block.rules[i].selected.id !== selection.id) {
              r.push({
                start: block.rules[i].selected.start,
                end: block.rules[i].selected.end
              });
          }
        }

        return r;
      },

      getEndBlockRestrictValues: function(block, selection) {
        var i, ii,
            r = [];

        for (i=0,ii=block.rules.length;i<ii;i++) {
          if (block.rules[i].selected &&
              block.rules[i].selected.id !== selection.id) {
            r.push({
              start: block.rules[i].selected.startMonthsBeforeEnd,
              end: block.rules[i].selected.endMonthsBeforeEnd
            });
          }
        }

        return r;
      },

      getGroupRestrictValues: function(block, selection) {
        var i, ii,
          j, jj,
          rule,
          r = [],
          blocks = {};

        if (!blocks.hasOwnProperty(block.restrict.rules.group)) {
          blocks[block.restrict.rules.group] = {
            order: block.restrict.order,
            start: 0,
            end: 0
          };
        }

        for (i=0,ii=this.blocks.length;i<ii;i++) {
          if (this.blocks[i].label !== block.label &&
              this.blocks[i].restrict.rules.group === block.restrict.rules.group) {
            for (j=0,jj=this.blocks[i].rules.length;j<jj;j++) {
              r.push({
                label: this.blocks[i].label,
                group: this.blocks[i].restrict.rules.group,
                order: this.blocks[i].restrict.order,
                start: this.blocks[i].rules[j].selected.start,
                end: this.blocks[i].rules[j].selected.end
              });
            }
          }
        }

        if (block.restrict.rules.overlapCascade) {

          r.sort(function (a, b) {
            var r = 0;

            if (a.order < b.order) {
              r = -1;
            } else if (a.order > b.order) {
              r = 1;
            }

            return r;
          });

          for (i = 0, ii = r.length; i < ii; i++) {
            if (r[i].group === block.restrict.rules.group) {
              if (r[i].end > blocks[block.restrict.rules.group].end) {
                blocks[block.restrict.rules.group].end = r[i].end;
              }
              // Hard coded to prevent anything from going backwards
              if (block.restrict.order === 1) {
                if (blocks[block.restrict.rules.group].start === 0) {
                  blocks[block.restrict.rules.group].start = r[i].start;
                }
                if (r[i].start < blocks[block.restrict.rules.group].start) {
                  blocks[block.restrict.rules.group].start = r[i].start;
                }
              }else {
                if (r[i].start < blocks[block.restrict.rules.group].start) {
                  blocks[block.restrict.rules.group].start = r[i].start;
                }
              }
            }
          }

          r = [];

          for (rule in blocks) {
            if (blocks.hasOwnProperty(rule)) {
              r.push(blocks[rule]);
            }
          }

        }

        return r;
      },

      updateRange: function(block, selection) {

        if (selection) {
          selection.expirationBased = !!selection.expirationBased;
          block.restrict.rangeOptions.disableDrag = false;
          if (selection.expirationBased) {
            selection.expRestrictions = [];
          }else{
            selection.restrictions = [];
          }
          selection.start = 0;
          selection.end = this.getValidEndMonth(block, 3);
          selection.monthsBeforeEnd = 3;
        }else{
          block.restrict.rangeOptions.disableDrag = true;
        }

        // next tick
        $timeout(function() {
          $scope.$broadcast('RuleBar::Update');
        }, 0);

        this.checkRanges();

      },

      updateRanges: function() {

        var i, ii;

        // Only update IN_TERM
        RulesEngineService.groups['IN_TERM'].rangeOptions.endRange = MembershipOfferingService.details.duration;

        // Only update AFTER_TERM if new range is greater than default
        if (RulesEngineService.groups['AFTER_TERM'].rangeOptions.defaultEndRange < MembershipOfferingService.details.duration) {
          RulesEngineService.groups['AFTER_TERM'].rangeOptions.endRange = MembershipOfferingService.details.duration;
        }else{
          RulesEngineService.groups['AFTER_TERM'].rangeOptions.endRange = RulesEngineService.groups['AFTER_TERM'].rangeOptions.defaultEndRange;
        }

        for (i = 0, ii = this.blocks.length; i < ii; i++) {
          this.blocks[i].restrict.rangeOptions.endRange = RulesEngineService.groups[this.blocks[i].restrict.rules.group].rangeOptions.endRange;
        }

      },

      updateOnExpirationBased: function(block, selection) {
        $scope.membershipOfferingsCreateLifecycle.updateRange(block, selection);
        $scope.membershipOfferingsCreateLifecycle.checkRange(block, selection);
      },

      checkRange: function(block, selection, checkAfterTermRanges) {

        var endMonth;

        if (selection) {

          if (selection.expirationBased) {
            selection.start = 0;
            selection.end = 0;
            selection.endMonthsBeforeEnd = block.restrict.rangeOptions.endRange;
            if ((selection.endMonthsBeforeEnd - selection.monthsBeforeEnd) < 0) {
              selection.endMonthsBeforeEnd += Math.abs(selection.startMonthsBeforeEnd);
            }
            selection.startMonthsBeforeEnd = selection.endMonthsBeforeEnd - selection.monthsBeforeEnd;
          }else{
            selection.startMonthsBeforeEnd = 0;
            selection.endMonthsBeforeEnd = 0;
            if (selection.start > selection.end) {

              if (selection.end < 0) {
                selection.end = 0;
              }

              selection.end = selection.start + 1;
            }

            if (selection.start > selection.end) {
              if (selection.end > 0) {
                selection.start = selection.end - 1;
              }
            }

            endMonth = this.getValidEndMonth(block, selection.end);

            this.afterTermMaxEndRange = this.getMaxEndRange();

            if (!block.inTerm && this.afterTermMaxEndRange !== 999 && this.afterTermMaxEndRange > MembershipOfferingService.details.duration) {
              block.restrict.rangeOptions.endRange = this.afterTermMaxEndRange;
            }

            selection.end = endMonth;
            selection.indefinite = (selection.end === 999);
          }

          this.checkRanges();
          if (!block.inTerm  && checkAfterTermRanges) {
            this.checkAfterTermRanges();
          }

        }

      },

      checkRanges: function() {

        var i, ii,
            j, jj;

        for (i=0,ii=this.blocks.length;i<ii;i++) {
          for (j=0,jj=this.blocks[i].rules.length;j<jj;j++) {
            if (this.blocks[i].rules[j] && this.blocks[i].rules[j].selected) {
              // Only check restrictions on non expiration based lifecycle action rules
              if (this.blocks[i].rules[j].selected.expirationBased) {
                this.blocks[i].rules[j].selected.start = 0;
                this.blocks[i].rules[j].selected.end = 0;
                this.blocks[i].rules[j].selected.restrictions = [];
                this.blocks[i].rules[j].selected.expRestrictions = this.checkRestrictions(this.blocks[i], this.blocks[i].rules[j].selected);
              }else{
                this.blocks[i].rules[j].selected.startMonthsBeforeEnd = 0;
                this.blocks[i].rules[j].selected.endMonthsBeforeEnd = 0;
                this.blocks[i].rules[j].selected.monthsBeforeEnd = 0;
                this.blocks[i].rules[j].selected.expRestrictions = [];
                this.blocks[i].rules[j].selected.restrictions = this.checkRestrictions(this.blocks[i], this.blocks[i].rules[j].selected);
              }
            }
          }
        }

        if (this.checkRangeTimer) {
          $timeout.cancel(this.checkRangeTimer);
        }
        // next tick
        this.checkRangeTimer = $timeout(function() {
          $scope.$broadcast('RuleBar::Update');
        }, 10);

      },

      checkAfterTermRanges: function() {

        var i, ii,
            j, jj;

        for (i=0,ii=this.blocks.length;i<ii;i++) {
          for (j=0,jj=this.blocks[i].rules.length;j<jj;j++) {
            if (this.blocks[i].inTerm === false &&
              this.blocks[i].rules[j] && this.blocks[i].rules[j].selected) {
              this.checkRange(this.blocks[i], this.blocks[i].rules[j].selected);
            }
          }
        }

      },

      checkRestrictions: function(block, selection) {

        var r = [];

        if (!block.restrict.rules.overlap) {
          if (selection.expirationBased) {
            r = r.concat(this.getEndBlockRestrictValues(block, selection));
          }else {
            r = r.concat(this.getBlockRestrictValues(block, selection));
          }
        }

        if (!block.restrict.rules.overlapGroup) {
          r = r.concat(this.getGroupRestrictValues(block, selection));
        }

        return r;

      },

      getMaxEndRange: function() {

        var i, ii,
            j, jj,
            values = [];

        for (i=0,ii=this.blocks.length;i<ii;i++) {
          for (j = 0, jj = this.blocks[i].rules.length; j < jj; j++) {
            values.push(this.blocks[i].rules[j].selected.end);
          }
        }

        return Math.max.apply(null, values);

      },

      getValidEndMonth: function(block, month) {
        var r = month;

        // 999 is the magic number for perpetual rules
        if (month === 999) {
          r = month;
        }else if (block.restrict.rules.group === 'IN_TERM' && month > MembershipOfferingService.details.duration) {
          r = MembershipOfferingService.details.duration;
        }

        return r;
      },

      setPerpetual: function(block, selection) {

        selection.indefinite = !selection.indefinite;

        if (selection.indefinite) {
          selection.lastEnd = selection.end;
          selection.end = 999; // Used for perpetual selections
        }else{
          if (selection.lastEnd) {
            if (selection.lastEnd === 999) {
              selection.end = block.restrict.rangeOptions.endRange;
            }else {
              selection.end = selection.lastEnd;
            }
          }else{
            selection.end = block.restrict.rangeOptions.endRange;
          }
        }

        // next tick
        $timeout(function() {
          $scope.membershipOfferingsCreateLifecycle.checkRange(block, selection, true);
        }, 0);

      },

      findTemplateBlock: function(id) {

        var i, ii,
            r = false;

        for (i=0,ii=this.templateBlocks.length;i<ii;i++) {
          if (this.templateBlocks[i].id === id) {
            r = {
              templateBlock: this.templateBlocks[i],
              index: i
            };
            break;
          }
        }

        return r;

      },

      findSelectedRuleAction: function(rule) {
        return RulesEngineService.findSelectedRuleAction(rule);
      },

      findCategoryRuleBySection: function(rule, section, describe) {
        return RulesEngineService.findCategoryRuleBySection(rule, section, describe);
      },

      findAction: function(category) {

        var i, ii,
            r = false;

        for (i=0,ii=this.model.length;i<ii;i++) {
          if (this.model[i].action === category) {
            r = {
              action: this.model[i],
              index: i
            };
            break;
          }
        }

        return r;

      },

      addAction: function(block, ruleInstance) {
        var offeringAction,
            found = this.findAction(block.label);

        if (found) {
          if (this.model[found.index].ruleIds.indexOf(ruleInstance.id) === -1) {
            this.model[found.index].ruleIds.push(ruleInstance.id);
          }
        }else {
          offeringAction = MembershipService.createOfferingAction();
          offeringAction.action = block.label;
          offeringAction.ruleIds = [ ruleInstance.id ];

          this.model.push(offeringAction);
        }
      },

      removeAction: function(block, ruleInstance) {
        var ruleIndex,
            found = this.findAction(block.label);

        if (found) {
          ruleIndex = this.model[found.index].ruleIds.indexOf(ruleInstance.id);
          if (ruleIndex > -1) {
            this.model[found.index].ruleIds.splice(ruleIndex, 1);
          }
        }
      },

      addRule: function(block, selectedRuleId) {

        var found = this.findTemplateBlock(block.id);

        block.rules.push({
          ruleId: selectedRuleId,
          categories: angular.copy(found.templateBlock.categories)
        });

      },

      showDetails: function(currentCategory) {
        var self = $scope.membershipOfferingsCreateLifecycle;

        self.showModal = $uibModal.open({
          templateUrl: 'views/application/views/membership/offerings/create/lifecycle/modals/details/details.tpl.html',
          size: 'md',
          controller: 'MembershipOfferingsCreateLifecycleModalsDetailsController',
          resolve: {
            currentCategory: function() {
              return currentCategory;
            }
          }
        });

        self.showModal.result.then(function () {
          // Invoked when modal completes with close(params)

        }, function (message) {
          // Invoked when modal completes with dismiss(params)

        });
      },

      validate: function() {
        var i, ii,
            j, jj,
            r = true;

        outer: for (i = 0, ii = this.blocks.length; i < ii; i++) {
          for (j = 0, jj = this.blocks[i].rules.length; j < jj; j++) {
            if (this.blocks[i].rules[j].selected &&
                this.blocks[i].rules[j].selected.conflicts ||
                this.blocks[i].rules[j].selected.expConflicts) {
              r = false;
              break outer;
            }
          }
        }

        return r;
      },

      save: function() {

        var i, ii,
            j, jj,
            q = $q.defer(),
            promises = [];

        if (this.validate()) {

          for (i=0,ii=this.blocks.length;i<ii;i++) {

            for (j=0,jj=this.blocks[i].rules.length;j<jj;j++) {

              if (this.blocks[i].rules[j].hasOwnProperty('saved') && this.blocks[i].rules[j].saved.id) {
                // If rule is already saved then update it
                // If rule matches selection then update
                if (this.blocks[i].rules[j].saved.ruleTemplateId === this.blocks[i].rules[j].selected.id) {
                  promises.push(this.updateRule(this.blocks[i], this.blocks[i].rules[j]));
                }else{
                  // If rule does not match selection then remove rule from DB and create a new one in its place
                  promises.push(this.deleteSavedRule(this.blocks[i], this.blocks[i].rules[j], true));
                  promises.push(this.createRule(this.blocks[i], this.blocks[i].rules[j]));
                }
              }else {
                // Nothing is saved so create a new rule
                promises.push(this.createRule(this.blocks[i], this.blocks[i].rules[j]));
              }

            }

          }

          if (promises.length) {
            $q.allSettled(promises).then(function (response) {
              var _response;

              while (_response = response.pop()) {

              }

              q.resolve(response);
            }, function(response) {
              $scope.$emit('MembershipOffering::Error', {
                tab: 'lifecycle',
                message: response.data.error
              });
            });
          }else{
            $timeout(function() {
              q.resolve(true);
            }, 10);
          }
        }else{
          $timeout(function() {
            q.reject({ data: { error: 'Resolve all conflicting rules before saving' }});
          }, 10);
        }

        return q.promise;

      },

      prepareTriggerRule: function(id, block, rule) {
        var trigger = {};

        trigger.id = id;
        trigger.expirationBased = rule.expirationBased;
        if (trigger.expirationBased) {
          trigger.monthsBeforeEnd = rule.monthsBeforeEnd || 0;

          trigger.startMonth = 0;
          trigger.endMonth = 0;
        }else{
          trigger.startMonth = rule.start;
          trigger.endMonth = this.getValidEndMonth(block, rule.end);

          trigger.monthsBeforeEnd = 0;
        }

        return trigger;

      },

      createRule: function(block, rule) {
        var trigger = {},
            q = $q.defer(),
            self = $scope.membershipOfferingsCreateLifecycle;

        // Only create if there is a selection
        if (rule.selected && rule.selected.id) {
          ApiService.rulesEngine.rule.create({templateId: rule.selected.id}).then(function (response) {
            trigger = self.prepareTriggerRule(response.data.payload.id, block, rule.selected);
            // Update newly created rule trigger action
            ApiService.rulesEngine.rule.updateTrigger(trigger).then(function (response) {

              // Apply saved rule to current data structure
              rule.saved = response.data.payload;
              rule.ruleId = rule.saved.id;

              // Add action to current model
              self.addAction(block, rule.saved);

              q.resolve(rule);
            }, function (response) {
              $scope.$emit('MembershipOffering::Error', {
                tab: 'lifecycle',
                message: response.data.error
              });
              q.reject(response.data.error);
            });
          }, function (response) {
            $scope.$emit('MembershipOffering::Error', {
              tab: 'lifecycle',
              message: response.data.error
            });
            q.reject(response.data.error);
          });
        }else{
          $timeout(function() {
            $scope.$emit('MembershipOffering::Error', {
              tab: 'lifecycle',
              message: 'Problem creating rule'
            });
            q.reject(rule);
          }, 10);
        }

        return q.promise;

      },

      updateRule: function(block, rule) {

        var trigger = this.prepareTriggerRule(rule.saved.id, block, rule.selected),
            q = $q.defer(),
            self = $scope.membershipOfferingsCreateLifecycle;

        ApiService.rulesEngine.rule.updateTrigger(trigger)
          .then(function(response) {

          // Assign saved rule
          rule.saved = response.data.payload;
          rule.ruleId = rule.saved.id;

          // Add action to current model
          self.addAction(block, rule.saved);

          q.resolve(rule);
        }, function(response) {
          self.notice.showErrorMessages([
            { message: response.data.error }
          ]);
          q.reject(response.data.error);
        });

        return q.promise;

      },

      deleteSavedRule: function(block, rule) {

        var q = $q.defer(),
            self = $scope.membershipOfferingsCreateLifecycle;

        $timeout(function() {
          if (rule.saved && rule.saved.id) {
            self.deletedRules.push(angular.copy(rule.saved));
            q.resolve(rule);
          }else{
            q.reject(rule);
          }
        }, 10);

        return q.promise;

      },

      removeRule: function(block, category, categoryIndex) {
        var self = $scope.membershipOfferingsCreateLifecycle;

        self.removeModal = $uibModal.open({
          templateUrl: 'views/application/views/membership/offerings/create/lifecycle/modals/remove/remove.tpl.html',
          size: 'md',
          controller: 'MembershipOfferingsCreateLifecycleModalsRemoveController',
          resolve: {
            currentCategory: function() {
              return category;
            }
          }
        });

        self.removeModal.result.then(function () {

          var i, ii;

          // Invoked when modal completes with close(params)
          for (i=0,ii=self.blocks.length;i<ii;i++) {
            if (self.blocks[i].label === block.label) {
              self.deleteSavedRule(block, category).then(angular.noop);
              self.blocks[i].rules.splice(categoryIndex, 1);
              break;
            }
          }

          // next tick
          $timeout(function() {
            self.checkRanges();
          }, 10);

        }, function (message) {
          // Invoked when modal completes with dismiss(params)

        });

      },

      process: function(blocks) {
        var i, ii,
            j, jj,
            block,
            label,
            found,
            r = [],
            ids = [],
            queue = [];

        for (i=0,ii=blocks.length;i<ii;i++) {
          label = RulesEngineService.nameToAction(blocks[i].name);

          block = {
            name: blocks[i].name,
            label: label,
            restrict: RulesEngineService.getRestrictionRules(label),
            id: blocks[i].id,
            description: blocks[i].description,
            hint: blocks[i].hint,
            inTerm: blocks[i].inTerm,
            rules: []
          };

          // Fetch rules individually
          found = RulesEngineService.getOfferingActionRules($scope.membershipOfferingsCreateLifecycle.offering, label);

          if (found) {
            ids = ids.concat(found.ruleIds);

            for (j = 0, jj = found.ruleIds.length; j < jj; j++) {
              this.addRule(block, found.ruleIds[j]);
            }
          }

          r.push(block);

        }

        for (i = 0, ii = ids.length; i < ii; i++) {
          queue.push(ApiService.rulesEngine.rule.detail({ id: ids[i] }));
        }

        $q.allSettled(queue).then(function(response) {

          var i, ii,
              j, jj,
              k, kk,
              rule,
              parts,
              _response,
              missingRuleId,
              self = $scope.membershipOfferingsCreateLifecycle;

          while (_response = response.pop()) {
            if (_response.data.error) {

              parts = _response.config.url.split('/');
              missingRuleId = parts[parts.length - 1];

              outer: for (i = 0, ii = r.length; i < ii; i++) {
                for (j = 0, jj = r[i].rules.length; j < jj; j++) {

                  if (r[i].rules[j].ruleId === missingRuleId) {
                    r[i].rules.splice(j, 1);
                    break outer;
                  }

                }

              }

            }else {
              rule = _response.data.payload;
              for (i = 0, ii = r.length; i < ii; i++) {
                for (j = 0, jj = r[i].rules.length; j < jj; j++) {
                  if (r[i].rules[j].ruleId === rule.id) {
                    r[i].rules[j].saved = rule;
                    for (k = 0, kk = r[i].rules[j].categories.length; k < kk; k++) {
                      if (r[i].rules[j].categories[k].id === rule.ruleTemplateId) {
                        r[i].rules[j].selected = r[i].rules[j].categories[k];
                        r[i].rules[j].selected.expirationBased = !!rule.trigger.paramValues.expirationBased;
                        r[i].rules[j].selected.start = rule.trigger.paramValues.startMonth || 0;
                        r[i].rules[j].selected.end = self.getValidEndMonth(r[i], rule.trigger.paramValues.endMonth || 3);
                        r[i].rules[j].selected.monthsBeforeEnd = rule.trigger.paramValues.monthsBeforeEnd || 3;
                        r[i].rules[j].selected.endMonthsBeforeEnd = MembershipOfferingService.details.duration;
                        r[i].rules[j].selected.startMonthsBeforeEnd = r[i].rules[j].selected.endMonthsBeforeEnd - r[i].rules[j].selected.monthsBeforeEnd;
                        r[i].rules[j].selected.indefinite = (r[i].rules[j].selected.end === 999);
                        break;
                      }
                    }
                  }
                }
              }
            }
          }

          $timeout(function() {
            self.updateRanges();
            self.checkRanges();
            $timeout(function() {
              self.checkRanges();
              MembershipOfferingService.loaded.lifecycle = true;
            }, 10);
          }, 10);

        });

        return r;
      },

      success: {
        init: function(response) {},
        save: function(response) {

          var self = $scope.membershipOfferingsCreateLifecycle;

          MembershipOfferingService.lifecycle = angular.copy(self.model);
          MembershipOfferingService.deletedRules = angular.copy(self.deletedRules);
          MembershipOfferingService.ready.lifecycle = true;

          self.deletedRules = [];
          MembershipOfferingService.purgeRules();

          $scope.$emit('MembershipOffering::Success', {
            tab: 'lifecycle',
            message: 'Successfully saved lifecycle rules'
          });
        }
      },

      error: {
        init: function(response) {},
        generic: function(response) {
          $scope.$emit('MembershipOffering::Error', {
            tab: 'lifecycle',
            message: response.data.error
          });
        },
        save: function(response) {
          $scope.membershipOfferingsCreateLifecycle.error.generic(response);
        }
      },

      onMembershipOfferingsCreateControllerSave: function(e, data) {

        var self = $scope.membershipOfferingsCreateLifecycle;

        $scope.membershipOfferingsCreateLifecycle.save().then(self.success.save, self.error.save);

      },

      onMembershipOfferingsCreateControllerUpdate: function(e, data) {

        var self = $scope.membershipOfferingsCreateLifecycle;

        self.offering = data.offering;

        // Templates from which to copy from
        self.templateBlocks = data.lifecycleRules;

        // Operating model
        self.blocks = self.process(self.templateBlocks);

        // Service copy of the data in case of cancel
        MembershipOfferingService.lifecycle = angular.copy(self.blocks);

        self.updateRanges();

      },

      onMembershipOfferingsCreateControllerFocusTab: function(e, data) {
        var self = $scope.membershipOfferingsCreateLifecycle;

        self.updateRanges();
        self.checkRanges();

        // Only check after term
        self.checkAfterTermRanges();

      },

      onRuleBarDragUpdate: function(e, data) {
        // next tick
        $timeout(function() {
          $scope.membershipOfferingsCreateLifecycle.checkRanges();
        }, 0);
      }

    };

    $scope.membershipOfferingsCreateLifecycle.init();

}]);